// management-frontend/src/services/apiServices.js

import axios from "axios";

class ApiServices {
  api;
  apiNotToken;

  constructor() {
    const token = localStorage.getItem("token");

    this.api = axios.create({
      baseURL: process.env.REACT_APP_API_URL,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    this.apiNotToken = axios.create({
      baseURL: process.env.REACT_APP_API_URL,
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  async post(path, body) {
    const config = {};
    const isFormData = body instanceof FormData;

    if (isFormData)
      config.headers = {
        "Content-Type": "multipart/form-data",
        Accept: "*/*",
      };

    return this.api
      .post(path, isFormData ? body : JSON.stringify(body), config)
      .then((res) => res.data)
      .catch((error) => error.response?.data || error.message);
  }

  async put(path, body) {
    return this.api
      .put(path, JSON.stringify(body))
      .then((res) => res.data)
      .catch((error) => error.response.data);
  }

  // --------------------------------------------------
  // ---                    Auth                    ---
  // --------------------------------------------------
  // Forgot Password
  async authForgot(email) {
    const { data } = await this.apiNotToken.post(`/Auth/ForgotPassword/${email}`);

    return data;
  }

  // Login
  async authLogin(email, password) {
    const { data } = await this.apiNotToken.post(`/Auth/Login`, { email, password });

    return data;
  }

  // Change Password
  async changePassword(id, password) {
    const { data } = await this.api.put(`/Users/${id}/Password`, { password });

    return data;
  }

  // --------------------------------------------------
  // ---                 Customers                  ---
  // --------------------------------------------------
  // Get All Customers
  async getAllCustomers() {
    const { data } = await this.api.get(`/Customer`);

    return data;
  }

  // Create Customer
  async createCustomer(data) {
    return await this.post(`/Customer`, data);
  }

  // Udpdate Customer
  async updateCustomer(id, data) {
    return await this.put(`/Customer/${id}`, data);
  }

  // Delete Customer
  async deleteCustomer(id) {
    return await this.api.delete(`/Customer/${id}`);
  }

  // Get Status Customer - System
  async getStatusByCustomer(id) {
    const { data } = await this.api.get(`/Customer/${id}/Status`);

    return data;
  }

  // --------------------------------------------------
  // ---             Customers System               ---
  // --------------------------------------------------
  // Get All Customers System
  async getAllCustomersSystem() {
    const { data } = await this.api.get(`/CustomerSystem`);

    return data;
  }

  // Get All Customers System
  async getCustomersSystem(id) {
    const { data } = await this.api.get(`/CustomerSystem/${id}`);

    return data;
  }

  // Create Customer System
  async createCustomerSystem(data) {
    return await this.post(`/CustomerSystem/`, data);
  }

  // Udpdate Customer System
  async updateCustomerSystem(id, data) {
    return await this.put(`/CustomerSystem/${id}`, data);
  }

  // Delete Customer System
  async deleteCustomerSystem(id) {
    return await this.api.delete(`/CustomerSystem/${id}`);
  }

  // --------------------------------------------------
  // ---                   Opervex                  ---
  // --------------------------------------------------
  async Synchronize(guid, apiValue) {
    try {
      const apiOpervex = await axios.create({
        baseURL: process.env.REACT_APP_API_OPERVEX,
        headers: {
          "X-API-KEY": apiValue,
          "Content-Type": "application/json",
        },
      });

      const response = await apiOpervex.post(`${guid}/System/Tenant/Synchronize/`);
      return response.data;
    } catch (error) {
      return error.response?.data || error.message;
    }
  }
}

export default ApiServices;
